// The installer's page header and its two tabs (Installs / Linked AWS accounts), shared by the
// session list and the per-customer accounts screen.
import type { ComponentChildren } from "preact";
import { LinkTabs, PageHeader } from "@nexus/ui";
import { installerTabs, type InstallerTab } from "./model";

export const INSTALLER_LEDE =
  "Sets up the Nexus proxy in a customer's AWS account. An AI agent plans each change, and you approve it before anything is created.";

export function InstallerHeader({ tab, orgId, actions }: { tab: InstallerTab; orgId: string | null; actions?: ComponentChildren }) {
  return (
    <>
      <PageHeader title="Installer" lede={INSTALLER_LEDE} actions={actions} />
      <LinkTabs label="Installer sections" tabs={installerTabs(orgId)} current={tab} />
    </>
  );
}
